import { render, staticRenderFns } from "./PuzzleBloc.vue?vue&type=template&id=55955b4c&lang=pug&"
import script from "./PuzzleBloc.vue?vue&type=script&lang=js&"
export * from "./PuzzleBloc.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleBloc.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55955b4c')) {
      api.createRecord('55955b4c', component.options)
    } else {
      api.reload('55955b4c', component.options)
    }
    module.hot.accept("./PuzzleBloc.vue?vue&type=template&id=55955b4c&lang=pug&", function () {
      api.rerender('55955b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/schematic/blocs/PuzzleBloc.vue"
export default component.exports